// src/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { url } from './Config';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const saved = localStorage.getItem('auth');
    return saved ? JSON.parse(saved) : null;
  });

  // ---------- CHECK TOKEN EXPIRY ----------
useEffect(() => {
  if (!user) return;

  try {
    const decoded = JSON.parse(atob(user.token.split(".")[1]));
    const expiryTime = decoded.exp * 1000;
    const currentTime = Date.now();

    const timeout = expiryTime - currentTime;

    if (timeout <= 0) {
      logout();
    } else {
      const timer = setTimeout(() => {
        logout();
      }, timeout);

      return () => clearTimeout(timer);
    }

  } catch (err) {
    logout();
  }
}, [user]);

  // ---------- LOGIN ----------
  const login = async (identifier, password) => {
    const res = await axios.post(`${url}/api/login`, { identifier, password });
    const token = res.data.token;

    const decoded = JSON.parse(atob(token.split('.')[1]));
    const userData = { ...decoded, token };

    localStorage.setItem('auth', JSON.stringify(userData));
    setUser(userData);

    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  };

  // ---------- LOGOUT ----------
  const logout = () => {
    setUser(null);
    localStorage.removeItem('auth');
    delete axios.defaults.headers.common['Authorization'];
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
